import EEICLAApiKeyService from '../services/eeicla-api-key-service';

export const eeiclaApiKey = {
  namespaced: true,
  state: {
    eeiclaApiKeys: [],
  },
  actions: {
    getAll({ commit }) {
      commit('setIsBusy', true, { root: true });
      commit('setEEICLAApiKeys', []);
      return EEICLAApiKeyService.getAll()
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setEEICLAApiKeys', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    create({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return EEICLAApiKeyService.create(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    delete({ commit }, tmApiKey) {
      commit('setIsBusy', true, { root: true });
      return EEICLAApiKeyService.delete(tmApiKey)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setEEICLAApiKeys(state, newEEICLAApiKeys) {
      state.eeiclaApiKeys = newEEICLAApiKeys;
    },
  },
};
